var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sizeing),expression:"sizeing"}],staticClass:"fm-table-cell-width-resize",style:({
  left: _vm.left + 'px'
})})
}
var staticRenderFns = []

export { render, staticRenderFns }